import React from "react";
import {
  ButtonContainer,
  ContentContainer,
  List,
  ListItem,
  MainContainer,
  ModalContainer,
  Subtext,
  Title,
} from "./styled";
import Header from "../../optics/components/header/Header";
import { useTranslation } from "react-i18next";
import { Button } from "@caelor/ui";
import { MACRO_KEY } from "../../optics/defaults";

const MACROS_WITH_MIGRATION = [MACRO_KEY.CARDS, MACRO_KEY.BUTTON_INLINE];

function EditDisabled({ macro, handleClickOnRebuild = () => {} }) {
  const { t } = useTranslation();
  const prefix = "edit-disabled.";
  const suffix = MACROS_WITH_MIGRATION.includes(macro) ? "-migration" : "";

  return (
    <ModalContainer>
      <Header hasSave={false} />
      <MainContainer>
        <ContentContainer>
          <Title>{t(prefix + "title" + suffix)}</Title>
          <Subtext>{t(prefix + "subtext" + suffix)}</Subtext>
          <List>
            <ListItem>{t(prefix + "list-1" + suffix)}</ListItem>
            <ListItem>{t(prefix + "list-2" + suffix)}</ListItem>
          </List>

          <ButtonContainer>
            <Button
              appearance="tertiary"
              onClick={() => window.AP.dialog.close()}
            >
              {t(prefix + "button-primary")}
            </Button>

            <Button
              appearance="secondary"
              onClick={() => handleClickOnRebuild(macro)}
            >
              {t(prefix + "button-secondary" + suffix)}
            </Button>
          </ButtonContainer>
        </ContentContainer>
      </MainContainer>
    </ModalContainer>
  );
}

export default EditDisabled;
